import { z } from 'zod';

const AmountRawSchema = z.string().regex(/^\d+$/).transform(BigInt);

export const RedemptionPaidEventSchema = z.object({
  redemptionId: z.string(),
  network: z.string(),
  usdcAmountRaw: AmountRawSchema,
  txHash: z.string(),
});

export const RedemptionFailedEventSchema = z.object({
  redemptionId: z.string(),
  reason: z.string(),
});

export type RedemptionPaidEvent = z.infer<typeof RedemptionPaidEventSchema>;
export type RedemptionFailedEvent = z.infer<typeof RedemptionFailedEventSchema>;
